import assoc from "ramda/es/assoc";
import reduce from "ramda/es/reduce";
export const flattenPermissions = (permissions)=>{
    return reduce((acc, perm)=>assoc(perm.permissionId, perm, acc), {}, permissions);
};
